export class SendUserOtp {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      successful: this.fields?.successful,
      msisdnMasked: this.fields?.msisdnMasked,
      emailMasked: this.fields?.emailMasked,
      message: this.fields?.message,
      locked: this.fields?.locked,
      forceRecaptcha: this.fields?.forceRecaptcha
    };
  }
}

export class SendOtp {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      sendAttempts: this.fields?.sendAttempts,
      type: this.fields?.destinationResults?.type,
      address: this.fields?.destinationResults?.address,
      success: this.fields?.destinationResults?.success,
      reasonOfFailure: this.fields?.destinationResults?.reasonOfFailure
    };
  }
}

export class VerifyUserOtp {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      access_token: this.fields?.access_token,
      token_type: this.fields?.token_type,
      expires_in: this.fields?.expires_in,
      scope: this.fields?.scope,
      jti: this.fields?.jti
    };
  }
}

export class VerifyOtp {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      access_token: this.fields?.access_token,
      token_type: this.fields?.token_type,
      expires_in: this.fields?.expires_in,
      scope: this.fields?.scope,
      jti: this.fields?.jti
    };
  }
}